// extracted by mini-css-extract-plugin
export default {"btnsContainer":"OrderSummary_btnsContainer__I9e89"};